// Import React and Dependencies
import React from 'react';
import { render } from 'react-snapshot';

// Import Router
import { BrowserRouter as Router } from 'react-router-dom';

// Import the App
import App from './App';

const rootElement = document.getElementById('root');
render(
  <Router>
    <App />
  </Router>,
  rootElement
);
